export var LegacyAction;
(function (LegacyAction) {
    LegacyAction["UploadItemToShareFile"] = "uploadItemToShareFile";
    LegacyAction["SendDocumentAndWaitForApproval"] = "sendDocumentAndWaitForApproval";
    LegacyAction["ConvertProspectToClient"] = "convertProspectToClient";
    LegacyAction["GetAgreementsFolderForClient"] = "getAgreementsFolderForClient";
    LegacyAction["SendClientAgreementAndWaitForSignature"] = "sendClientAgreementAndWaitForSignature";
    LegacyAction["SendTemplateAndWaitForSignature"] = "sendTemplateAndWaitForSignature";
    LegacyAction["SendEmail"] = "sendEmail";
})(LegacyAction || (LegacyAction = {}));
//# sourceMappingURL=legacyActions.js.map